export default __webpack_public_path__ + "static/media/944.f2952fa1.gif";